import Button from "../../../components/button/Button";
import ArrowSmall from "../../../components/svg/ArrowSmall";
import { useSelector } from "react-redux";
import { selectOpenBills } from "../../../features/reservation/reservationSlice";
import OpenBillsCard from "../../../components/kiosk/OpenBillsCard";
import { resetReservations } from "../../../helpers/reservation";
import { useNavigate } from "react-router-dom";

export default function PreAuthExpense() {
	const openBills = useSelector(selectOpenBills);
	const navigate = useNavigate();

	return (
		<>
			{openBills && (
				<div className="flex-grow flex justify-center items-center flex-col w-full">
					<div className="text-h1 text-center">
						These have been your consumptions during your stay.
					</div>
					<div className="mt-12 w-full">
						<OpenBillsCard openBills={openBills} />
					</div>
					<div className="mt-6 flex justify-between items-center w-full text-h3 text-center">
						<Button
							onClick={() => resetReservations()}
							type="button"
							text="Close"
							suffix={<ArrowSmall />}
						/>
					</div>
					{openBills.Total.GrossValue > 0 && (
						<div className="mt-6 flex justify-between items-center w-full text-h3 text-center">
							<Button
								onClick={() => navigate("/kiosk/check-expense/open-bills")}
								type="button"
								text="Or pay now"
								style="secondary"
								suffix={<ArrowSmall />}
							/>
						</div>
					)}
				</div>
			)}
		</>
	);
}
